import { defineAsyncComponent } from 'vue'
import type { RoundTypeHandler } from '../RoundTypeHandler'

/**
 * Classic Q&A Round Type Plugin
 * Traditional question-answer format with markdown content
 * Typically used with buzzer or manual scoring
 */
export const classicQAHandler: RoundTypeHandler = {
  type: 'CLASSIC_QA',
  label: 'Classic Q&A',
  icon: 'mdi-comment-question-outline',
  description: 'Traditional question and answer format with markdown support',

  // Lazy-loaded components
  ModeratorView: defineAsyncComponent(
    () => import('./QAModeratorView.vue')
  ),
  TeamView: defineAsyncComponent(
    () => import('./QATeamView.vue')
  ),

  capabilities: {
    timer: true,
    buzzer: true,
    submissions: false, // Classic Q&A typically uses buzzer, not submissions
    autoValidation: false
  },

  parseConfig(configJson: string) {
    // Classic Q&A typically doesn't have complex config
    try {
      return JSON.parse(configJson)
    } catch (error) {
      return {}
    }
  },

  validateConfig(_config: any): true | string {
    void _config
    // Classic Q&A is flexible - no strict validation needed
    return true
  }
}

// Export for direct import
export { useQARound } from './useQARound'
